import { PRODUCT_PAGE_REACT_QUERY_241007 } from "@faire/web-api/indigofair/settings/PRODUCT_PAGE_REACT_QUERY_241007";

import { useBooleanSetting } from "@faire/retailer/settings/useBooleanSetting";

export const useSettingProductPageReactQuery = (): boolean => {
  return useBooleanSetting(PRODUCT_PAGE_REACT_QUERY_241007);
};
